import React from 'react';
import { IPostingFieldContents } from '@medely/types';
import { formatContentBasedOnDescription } from './postingFieldsDisplayHelpers';
import { Box, HStack, Label, Text } from '@medely/ui-kit';
import { gateNames } from '@mp/constants';
import { useGate } from '@mp/hooks';

export const PostingFieldsGroup = ({
  postingFieldContents,
}: {
  postingFieldContents: IPostingFieldContents | undefined;
}) => {
  const keys = !!postingFieldContents ? Object.keys(postingFieldContents) : [];
  const isNewFacilityGuideFormat = useGate(gateNames.facilityGuide);

  return (
    <Box py={isNewFacilityGuideFormat ? 0 : 1} width="100%">
      {postingFieldContents &&
        keys.map((key) => (
          <HStack mt={isNewFacilityGuideFormat ? 0 : 2} key={key} gap={0.5} flexWrap="wrap">
            <Text size="m" color="text.secondary">
              {`• ${postingFieldContents[key].label}:`}
            </Text>
            <Label size="m" color="text.secondary">
              {formatContentBasedOnDescription(
                postingFieldContents[key].description,
                postingFieldContents[key].content,
              )}
            </Label>
          </HStack>
        ))}
    </Box>
  );
};
